import { Panel } from "@xyflow/react";
import { Spinner, Text } from "@zapier/design-system";
import { useAtomValue } from "jotai";
import { tourLoadingIndicatorMessageAtom } from "@zapier/canvas-state";
import styles from "./TourLoadingIndicator.module.css";

export function TourLoadingIndicator() {
  const message = useAtomValue(tourLoadingIndicatorMessageAtom);

  return (
    <Panel position="top-left">
      <div
        className={styles.loadingWrapper}
        data-testid="tour-loading-indicator"
      >
        <Spinner size="small" />
        <Text type="MinimalPrint1" color="TextWeaker">
          {message}
        </Text>
      </div>
    </Panel>
  );
}
